import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { ICatalog } from '@shared/models/icommons.model';
import { ElementType } from './enums';
import { FooterElement, FooterOptions, TypeaheadOptions } from './interfaces';

@Component({
  selector: 'miq-search-typeahead',
  templateUrl: './search-typeahead.component.html',
  styleUrls: ['./search-typeahead.component.scss'],
  standalone: false,
})
export class SearchTypeaheadComponent {
  @Input() searchResults: Array<ICatalog & { formattedValue?: string }> = [];
  @Input() options?: TypeaheadOptions;

  @Output() execute = new EventEmitter<ICatalog & { formattedValue?: string }>();
  @Output() customCommand = new EventEmitter<string>();
  @Output() clickOutside = new EventEmitter<any>();

  get footerOptions(): FooterOptions {
    return this.options && this.options.footer;
  }

  get footerElements(): FooterElement[] {
    return this.footerOptions && this.footerOptions.elements;
  }

  protected elementType = ElementType;

  @HostListener('document:click', ['$event']) clickedOutside($event) {
    this.clickOutside.emit($event);
  }
}
